import React, {useCallback, useEffect, useState} from "react";
import BasicGrid from "../../../grid/BasicGrid";
import {getSkillTypes} from "../../../../service/dataService";
import {Button, Stack, toaster} from "rsuite";
import SuccessNotification from "../../../notifications/SuccessNotification";
import {
    SKILL_TYPE_ADD_ERROR,
    SKILL_TYPE_ADD_SUCCESS,
    SKILL_TYPE_EDIT_ERROR,
    SKILL_TYPE_EDIT_SUCCESS,
} from "../../../../service/constants";
import ErrorNotification from "../../../notifications/ErrorNotification";
import AddSkillTypeModal from "../../../modals/admin/skills/AddSkillTypeModal";
import EditSkillTypeModal from "../../../modals/admin/skills/EditSkillTypeModal";

const defaultColumns = [
    {
        key: 'id',
        label: 'Id',
    },
    {
        key: 'skillTypeName',
        label: 'Skill Type Name',
        flexGrow: 2,
    },
];

const SkillTypes = () => {
    const [skillTypes, setSkillTypes] = useState([]);
    const [loading, setLoading] = useState(false);

    // add modal
    const [addModalOpen, setAddModalOpen] = useState(false);

    // edit modal
    const [selectedSkillType, setSelectedSkillType] = useState({});
    const [editModalOpen, setEditModalOpen] = useState(false);

    // table
    const [columnKeys] = useState(defaultColumns.map(column => column.key));
    const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key));

    const loadSkillTypes = useCallback(() => {
        setLoading(true);
        getSkillTypes().then((data) => {
                // format the data into InputPicker format for now
                setSkillTypes(data);
                setLoading(false);
            }
        );
    }, []);

    useEffect(() => {
        loadSkillTypes();
    }, [loadSkillTypes]);


    const setClickedSkill = useCallback((rowData) => {
        setEditModalOpen(true);
        setSelectedSkillType(rowData);
    },[]);

    const handleAddClose = useCallback(({result}) => {
        if(result === 'success') {
            toaster.push(<SuccessNotification message={SKILL_TYPE_ADD_SUCCESS} />, { placement: 'topCenter' });
            loadSkillTypes();
        } else if (result === 'error') {
            toaster.push(<ErrorNotification message={SKILL_TYPE_ADD_ERROR} />, { placement: 'topCenter' });
        }
        setAddModalOpen(false);
    },[loadSkillTypes]);

    const handleEditClose = useCallback(({result}) => {
        if(result === 'success') {
            toaster.push(<SuccessNotification message={SKILL_TYPE_EDIT_SUCCESS} />, { placement: 'topCenter' });
            loadSkillTypes();
        } else if (result === 'error') {
            toaster.push(<ErrorNotification message={SKILL_TYPE_EDIT_ERROR} />, { placement: 'topCenter' });
        }
        setEditModalOpen(false);
    },[loadSkillTypes]);

    return (
        <>
            <Stack spacing={2} direction='column' alignItems='flex-start'>
                <p>Click to edit/delete skill type.</p>
                <p>
                    Changes/removal will cascade to all skills under the skill type.
                </p>
                <p>
                    <b>Warning:</b> Deleting a skill type will remove ALL skills of this type for all users.
                </p>
                <Button appearance="primary"
                        onClick={() => setAddModalOpen(true)}
                        style={{marginBottom: '1rem'}}
                >
                    Add Skill Type
                </Button>
            </Stack>
            <BasicGrid
                loading={loading}
                columns={columns}
                data={skillTypes}
                handleClick={setClickedSkill}
                exportTitle="admin-skill-type-list"
            />
            <AddSkillTypeModal
                open={addModalOpen}
                handleClose={handleAddClose}
                skillTypes={skillTypes}
            />
            <EditSkillTypeModal
                open={editModalOpen}
                handleClose={handleEditClose}
                selectedSkillType={selectedSkillType}
            />
        </>
    );
};

export default SkillTypes;